module.exports = __webpack_public_path__ + "static/media/14.70f1b2d7.png";